export default {"src":"/_next/static/media/light-grey-left.e56790c3.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};